import React, { useState, useEffect, useRef } from 'react'
import { useAppDataContext } from '../../__providers/AppProvider'
import Button from '@material-ui/core/Button'

//styles
import '../../assets/css/interactive-road-signals.css'

//modals
import InfoModal from '../modals/interactive_road_signals/Info'

//images
import lampIcon from '../../assets/images/interactive-road-signals/icons/lamp.png'
import lampBigIcon from '../../assets/images/interactive-road-signals/icons/lamp-big.png'
import rightArrowIcon from '../../assets/images/interactive-road-signals/icons/right-arrow.png'
import infoIcon from '../../assets/images/interactive-road-signals/icons/info.png'
import lampOffIcon from '../../assets/images/interactive-road-signals/icons/lamp-off.png'
import loader from '../../assets/images/interactive-road-signals/loader.svg'

//START group icons
import groupAIcon from '../../assets/images/interactive-road-signals/icons/group-a.png'
import groupBIcon from '../../assets/images/interactive-road-signals/icons/group-b.png'
import groupVIcon from '../../assets/images/interactive-road-signals/icons/group-v.png'
import groupGIcon from '../../assets/images/interactive-road-signals/icons/group-g.png'
import groupDIcon from '../../assets/images/interactive-road-signals/icons/group-d.png'
import groupEIcon from '../../assets/images/interactive-road-signals/icons/group-e.png'
import groupJIcon from '../../assets/images/interactive-road-signals/icons/group-j.png'
import groupTIcon from '../../assets/images/interactive-road-signals/icons/group-t.png'
import signalMethodsIcon from '../../assets/images/interactive-road-signals/icons/signal-methods.png'
import trafficPoliceIcon from '../../assets/images/interactive-road-signals/icons/traffic-police.png'
import trafficLightIcon from '../../assets/images/interactive-road-signals/icons/traffic-light.png'
//END group icons

//START sign icons

//
//ИМЕ НА ГРУПАТА_НОМЕР НА ТАЛОТО <------
//

//POSTER 1
import a1_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_03.png'
import a2_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_04.png'
import a3_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_05.png'
import a4_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_06.png'
import a5_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_08.png'
import a6_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_09.png'
import a7_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_10.png'
import a8_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_11.png'
import a9_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_12.png'
import a10_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_13.png'
import a11_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_14.png'
import a12_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_15.png'
import a13_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_16.png'
import a14_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_17.png'
import a15_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_18.png'
import a16_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_19.png'
import a17_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_20.png'
import a18_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_21.png'
import a19_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_22.png'
import a20_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_23.png'
import a21_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_24.png'
import a22_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_25.png'
import a23_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_26.png'
import a24_1 from '../../assets/images/interactive-road-signals/signs/A1/images/1_A1_27.png'
//POSTER 2
import a25_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_03.png'
import a26_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_04.png'
import a27_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_05.png'
import a28_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_06.png'
import a29_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_08.png'
import a30_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_09.png'
import a31_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_10.png'
import a32_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_11.png'
import a33_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_12.png'
import a34_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_13.png'
import a35_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_14.png'
import a36_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_15.png'
import a37_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_16.png'
import a38_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_17.png'
import a39_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_18.png'
import a40_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_19.png'
import a41_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_20.png'
import a42_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_21.png'
import a43_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_22.png'
import a44_2 from '../../assets/images/interactive-road-signals/signs/A2/images/A2_23.png'
//POSTER 3
import b1_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_03.png'
import b2_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_04.png'
import b3_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_05.png'
import b4_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_06.png'
import b5_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_08.png'
import b6_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_09.png'
import v1_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_16.png'
import v2_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_17.png'
import v3_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_18.png'
import v4_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_19.png'
import v5_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_20.png'
import v6_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_21.png'
import v7_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_22.png'
import v8_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_23.png'
import v9_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_24.png'
import v10_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_25.png'
import v11_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_26.png'
import v12_3 from '../../assets/images/interactive-road-signals/signs/B_V1/images/1_A1_27.png'
//POSTER 4
import v13_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_03.png'
import v14_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_04.png'
import v15_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_05.png'
import v16_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_06.png'
import v17_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_08.png'
import v18_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_09.png'
import v19_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_10.png'
import v20_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_11.png'
import v21_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_12.png'
import v22_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_13.png'
import v23_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_14.png'
import v24_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_15.png'
import v25_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_16.png'
import v26_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_17.png'
import v27_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_18.png'
import v28_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_19.png'
import v29_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_20.png'
import v30_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_21.png'
import v31_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_22.png'
import v32_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_23.png'
import v33_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_24.png'
import v34_4 from '../../assets/images/interactive-road-signals/signs/V2/images/V2_25.png'
//POSTER 5
import g1_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_03.png'
import g2_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_04.png'
import g3_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_05.png'
import g4_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_06.png'
import g5_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_08.png'
import g6_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_09.png'
import g7_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_10.png'
import g8_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_11.png'
import g9_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_12.png'
import g10_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_13.png'
import g11_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_14.png'
import g12_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_15.png'
import g13_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_16.png'
import g14_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_17.png'
import g15_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_18.png'
import g16_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_19.png'
import g17_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_20.png'
import g18_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_21.png'
import g19_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_22.png'
import g20_5 from '../../assets/images/interactive-road-signals/signs/G/images/images/1_A1_23.png'
//POSTER 6
import d1_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_03.png'
import d2_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_04.png'
import d3_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_05.png'
import d4_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_06.png'
import d5_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_08.png'
import d6_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_09.png'
import d7_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_10.png'
import d8_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_11.png'
import d9_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_12.png'
import d10_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_13.png'
import d11_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_14.png'
import d12_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_15.png'
import d13_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_16.png'
import d14_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_17.png'
import d15_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_18.png'
import d16_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_19.png'
import d17_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_20.png'
import d18_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_21.png'
import d19_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_22.png'
import d20_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_23.png'
import d21_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_24.png'
import d22_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_25.png'
import d23_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_26.png'
import d24_6 from '../../assets/images/interactive-road-signals/signs/D1/images/1_A1_27.png'
//POSTER 7 
import d25_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_03.png'
import d26_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_04.png'
import d27_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_05.png'
import d28_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_06.png'
import d29_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_08.png'
import d30_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_09.png'
import e1_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_16.png'
import e2_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_17.png'
import e3_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_18.png'
import e4_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_19.png'
import e5_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_20.png'
import e6_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_21.png'
import e7_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_22.png'
import e8_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_23.png'
import e9_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_24.png'
import e10_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_25.png'
import e11_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_26.png'
import e12_7 from '../../assets/images/interactive-road-signals/signs/D2_E1/images/1_A1_27.png'
//POSTER 8
import e13_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_03.png'
import e14_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_04.png'
import e15_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_05.png'
import e16_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_06.png'
import e17_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_08.png'
import e18_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_09.png'
import e19_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_10.png'
import e20_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_11.png'
import e21_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_12.png'
import e22_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_13.png'
import e23_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_14.png'
import e24_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_15.png'
import e25_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_16.png'
import e26_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_17.png'
import j1_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_24.png'
import j2_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_25.png'
import j3_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_26.png'
import j4_8 from '../../assets/images/interactive-road-signals/signs/E2_J1/images/1_A1_27.png'
//POSTER 9
import j5_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_03.png'
import j6_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_04.png'
import j7_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_05.png'
import j8_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_06.png'
import j9_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_08.png'
import j10_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_09.png'
import j11_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_10.png'
import j12_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_11.png'
import j13_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_12.png'
import j14_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_13.png'
import j15_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_14.png'
import j16_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_15.png'
import j17_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_16.png'
import j18_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_17.png'
import j19_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_18.png'
import j20_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_19.png'
import j21_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_20.png'
import j22_9 from '../../assets/images/interactive-road-signals/signs/J2/images/1_A1_21.png'
//POSTER 10
import t1_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_03.png'
import t2_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_04.png'
import t3_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_05.png'
import t4_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_06.png'
import t5_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_08.png'
import t6_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_09.png'
import t7_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_10.png'
import t8_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_11.png'
import t9_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_12.png'
import t10_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_13.png'
import t11_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_14.png'
import t12_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_15.png'
import t13_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_16.png'
import t14_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_17.png'
import t15_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_18.png'
import t16_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_19.png'
import t17_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_20.png'
import t18_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_21.png'
import t19_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_22.png'
import t20_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_23.png'
import t21_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_24.png'
import t22_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_25.png'
import t23_10 from '../../assets/images/interactive-road-signals/signs/T/images/1_A1_26.png'
//POSTER 11
import tl1_11 from '../../assets/images/interactive-road-signals/signs/traffic_lights/1.png'
import tl2_11 from '../../assets/images/interactive-road-signals/signs/traffic_lights/2.png'
import tl3_11 from '../../assets/images/interactive-road-signals/signs/traffic_lights/3.png'
import tl4_11 from '../../assets/images/interactive-road-signals/signs/traffic_lights/4.png'
import tl5_11 from '../../assets/images/interactive-road-signals/signs/traffic_lights/5.png'
import tl6_11 from '../../assets/images/interactive-road-signals/signs/traffic_lights/6.png'
import tl7_11 from '../../assets/images/interactive-road-signals/signs/traffic_lights/7.png'
import tl8_11 from '../../assets/images/interactive-road-signals/signs/traffic_lights/8.png'
import tl9_11 from '../../assets/images/interactive-road-signals/signs/traffic_lights/9.png'
//POSTER 12
import tp1_12 from '../../assets/images/interactive-road-signals/signs/traffic_police/1.png'
import tp2_12 from '../../assets/images/interactive-road-signals/signs/traffic_police/2.png'
import tp3_12 from '../../assets/images/interactive-road-signals/signs/traffic_police/3.png'
import tp4_12 from '../../assets/images/interactive-road-signals/signs/traffic_police/4.png'
import tp5_12 from '../../assets/images/interactive-road-signals/signs/traffic_police/5.png'
import tp6_12 from '../../assets/images/interactive-road-signals/signs/traffic_police/6.png'
import tp7_12 from '../../assets/images/interactive-road-signals/signs/traffic_police/7.png'
import tp8_12 from '../../assets/images/interactive-road-signals/signs/traffic_police/8.png'
import tp9_12 from '../../assets/images/interactive-road-signals/signs/traffic_police/9.png'
//POSTER 13
import sm1_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_03.png'
import sm2_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_04.png'
import sm3_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_05.png'
import sm4_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_06.png'
import sm5_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_08.png'
import sm6_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_09.png'
import sm7_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_10.png'
import sm8_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_11.png'
import sm9_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_12.png'
import sm10_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_13.png'
import sm11_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_14.png'
import sm12_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_15.png'
import sm13_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_16.png'
import sm14_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_17.png'
import sm15_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_18.png'
import sm16_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_19.png'
import sm17_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_20.png'
import sm18_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_21.png'
import sm19_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_22.png'
import sm20_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_23.png'
import sm21_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_24.png'
import sm22_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_25.png'
import sm23_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_26.png'
import sm24_13 from '../../assets/images/interactive-road-signals/signs/signal_methods/images/1_A1_27.png'
//END sign icons

var images = {
    'groupAIcon': groupAIcon,
    'groupBIcon': groupBIcon,
    'groupVIcon': groupVIcon,
    'groupGIcon': groupGIcon,
    'groupDIcon': groupDIcon,
    'groupEIcon': groupEIcon,
    'groupJIcon': groupJIcon,
    'groupTIcon': groupTIcon,
    'signalMethodsIcon': signalMethodsIcon,
    'trafficPoliceIcon': trafficPoliceIcon,
    'trafficLightIcon': trafficLightIcon,

    //POSTER 1
    'a1_1': a1_1,
    'a2_1': a2_1,
    'a3_1': a3_1,
    'a4_1': a4_1,
    'a5_1': a5_1,
    'a6_1': a6_1,
    'a7_1': a7_1,
    'a8_1': a8_1,
    'a9_1': a9_1,
    'a10_1': a10_1,
    'a11_1': a11_1,
    'a12_1': a12_1,
    'a13_1': a13_1,
    'a14_1': a14_1,
    'a15_1': a15_1,
    'a16_1': a16_1,
    'a17_1': a17_1,
    'a18_1': a18_1,
    'a19_1': a19_1,
    'a20_1': a20_1,
    'a21_1': a21_1,
    'a22_1': a22_1,
    'a23_1': a23_1,
    'a24_1': a24_1,

    //POSTER 2
    'a25_2': a25_2,
    'a26_2': a26_2,
    'a27_2': a27_2,
    'a28_2': a28_2,
    'a29_2': a29_2,
    'a30_2': a30_2,
    'a31_2': a31_2,
    'a32_2': a32_2,
    'a33_2': a33_2,
    'a34_2': a34_2,
    'a35_2': a35_2,
    'a36_2': a36_2,
    'a37_2': a37_2,
    'a38_2': a38_2,
    'a39_2': a39_2,
    'a40_2': a40_2,
    'a41_2': a41_2,
    'a42_2': a42_2,
    'a43_2': a43_2,
    'a44_2': a44_2,

    //POSTER 3
    'b1_3': b1_3,
    'b2_3': b2_3,
    'b3_3': b3_3,
    'b4_3': b4_3,
    'b5_3': b5_3,
    'b6_3': b6_3,

    'v1_3': v1_3,
    'v2_3': v2_3,
    'v3_3': v3_3,
    'v4_3': v4_3,
    'v5_3': v5_3,
    'v6_3': v6_3,
    'v7_3': v7_3,
    'v8_3': v8_3,
    'v9_3': v9_3,
    'v10_3': v10_3,
    'v11_3': v11_3,
    'v12_3': v12_3,

    //POSTER 4
    'v13_4': v13_4,
    'v14_4': v14_4,
    'v15_4': v15_4,
    'v16_4': v16_4,
    'v17_4': v17_4,
    'v18_4': v18_4,
    'v19_4': v19_4,
    'v20_4': v20_4,
    'v21_4': v21_4,
    'v22_4': v22_4,
    'v23_4': v23_4,
    'v24_4': v24_4,
    'v25_4': v25_4,
    'v26_4': v26_4,
    'v27_4': v27_4,
    'v28_4': v28_4,
    'v29_4': v29_4,
    'v30_4': v30_4,
    'v31_4': v31_4,
    'v32_4': v32_4,
    'v33_4': v33_4,
    'v34_4': v34_4,

    //POSTER 5
    'g1_5': g1_5,
    'g2_5': g2_5,
    'g3_5': g3_5,
    'g4_5': g4_5,
    'g5_5': g5_5,
    'g6_5': g6_5,
    'g7_5': g7_5,
    'g8_5': g8_5,
    'g9_5': g9_5,
    'g10_5': g10_5,
    'g11_5': g11_5,
    'g12_5': g12_5,
    'g13_5': g13_5,
    'g14_5': g14_5,
    'g15_5': g15_5,
    'g16_5': g16_5,
    'g17_5': g17_5,
    'g18_5': g18_5,
    'g19_5': g19_5,
    'g20_5': g20_5,

    //POSTER 6
    'd1_6': d1_6,
    'd2_6': d2_6,
    'd3_6': d3_6,
    'd4_6': d4_6,
    'd5_6': d5_6,
    'd6_6': d6_6,
    'd7_6': d7_6,
    'd8_6': d8_6,
    'd9_6': d9_6,
    'd10_6': d10_6,
    'd11_6': d11_6,
    'd12_6': d12_6,
    'd13_6': d13_6,
    'd14_6': d14_6,
    'd15_6': d15_6,
    'd16_6': d16_6,
    'd17_6': d17_6,
    'd18_6': d18_6,
    'd19_6': d19_6,
    'd20_6': d20_6,
    'd21_6': d21_6,
    'd22_6': d22_6,
    'd23_6': d23_6,
    'd24_6': d24_6,

    //POSTER 7 
    'd25_7': d25_7,
    'd26_7': d26_7,
    'd27_7': d27_7,
    'd28_7': d28_7,
    'd29_7': d29_7,
    'd30_7': d30_7,

    'e1_7': e1_7,
    'e2_7': e2_7,
    'e3_7': e3_7,
    'e4_7': e4_7,
    'e5_7': e5_7,
    'e6_7': e6_7,
    'e7_7': e7_7,
    'e8_7': e8_7,
    'e9_7': e9_7,
    'e10_7': e10_7,
    'e11_7': e11_7,
    'e12_7': e12_7,

    //POSTER 8
    'e13_8': e13_8,
    'e14_8': e14_8,
    'e15_8': e15_8,
    'e16_8': e16_8,
    'e17_8': e17_8,
    'e18_8': e18_8,
    'e19_8': e19_8,
    'e20_8': e20_8,
    'e21_8': e21_8,
    'e22_8': e22_8,
    'e23_8': e23_8,
    'e24_8': e24_8,
    'e25_8': e25_8,
    'e26_8': e26_8,

    'j1_8': j1_8,
    'j2_8': j2_8,
    'j3_8': j3_8,
    'j4_8': j4_8,

    //POSTER 9
    'j5_9': j5_9,
    'j6_9': j6_9,
    'j7_9': j7_9,
    'j8_9': j8_9,
    'j9_9': j9_9,
    'j10_9': j10_9,
    'j11_9': j11_9,
    'j12_9': j12_9,
    'j13_9': j13_9,
    'j14_9': j14_9,
    'j15_9': j15_9,
    'j16_9': j16_9,
    'j17_9': j17_9,
    'j18_9': j18_9,
    'j19_9': j19_9,
    'j20_9': j20_9,
    'j21_9': j21_9,
    'j22_9': j22_9,

    //POSTER 10
    't1_10': t1_10,
    't2_10': t2_10,
    't3_10': t3_10,
    't4_10': t4_10,
    't5_10': t5_10,
    't6_10': t6_10,
    't7_10': t7_10,
    't8_10': t8_10,
    't9_10': t9_10,
    't10_10': t10_10,
    't11_10': t11_10,
    't12_10': t12_10,
    't13_10': t13_10,
    't14_10': t14_10,
    't15_10': t15_10,
    't16_10': t16_10,
    't17_10': t17_10,
    't18_10': t18_10,
    't19_10': t19_10,
    't20_10': t20_10,
    't21_10': t21_10,
    't22_10': t22_10,
    't23_10': t23_10,

    //POSTER 11
    'tl1_11': tl1_11,
    'tl2_11': tl2_11,
    'tl3_11': tl3_11,
    'tl4_11': tl4_11,
    'tl5_11': tl5_11,
    'tl6_11': tl6_11,
    'tl7_11': tl7_11,
    'tl8_11': tl8_11,
    'tl9_11': tl9_11,

    //POSTER 12
    'tp1_12': tp1_12,
    'tp2_12': tp2_12,
    'tp3_12': tp3_12,
    'tp4_12': tp4_12,
    'tp5_12': tp5_12,
    'tp6_12': tp6_12,
    'tp7_12': tp7_12,
    'tp8_12': tp8_12,
    'tp9_12': tp9_12,

    //POSTER 13
    'sm1_13': sm1_13,
    'sm2_13': sm2_13,
    'sm3_13': sm3_13,
    'sm4_13': sm4_13,
    'sm5_13': sm5_13,
    'sm6_13': sm6_13,
    'sm7_13': sm7_13,
    'sm8_13': sm8_13,
    'sm9_13': sm9_13,
    'sm10_13': sm10_13,
    'sm11_13': sm11_13,
    'sm12_13': sm12_13,
    'sm13_13': sm13_13,
    'sm14_13': sm14_13,
    'sm15_13': sm15_13,
    'sm16_13': sm16_13,
    'sm17_13': sm17_13,
    'sm18_13': sm18_13,
    'sm19_13': sm19_13,
    'sm20_13': sm20_13,
    'sm21_13': sm21_13,
    'sm22_13': sm22_13,
    'sm23_13': sm23_13,
    'sm24_13': sm24_13

};

export default () => {
    const app = useAppDataContext()

    const [state, setState] = useState({
        data: app.boardStatus.data,
        // data: [
        //     {
        //         id: 1,
        //         name: 'Група A',
        //         icon: groupAIcon,
        //         isSign: true,
        //         allSwichedOn: false,
        //         signals: [
        //             {
        //                 id: 1,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А1',
        //                 image: a1_1,
        //                 swichdOn: false,
        //                 info: 'Опасен завой надясно'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А2',
        //                 image: a2_1,
        //                 swichdOn: false,
        //                 info: 'Опасен завой наляво'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А3',
        //                 image: a3_1,
        //                 swichdOn: false,
        //                 info: 'Последователни опасни завои, първият от които е надясно'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А4',
        //                 image: a4_1,
        //                 swichdOn: false,
        //                 info: 'Последователни опасни завои, първият от които е наляво'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А5',
        //                 image: a5_1,
        //                 swichdOn: false,
        //                 info: 'Стръмен наклон при спускане'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А6',
        //                 image: a6_1,
        //                 swichdOn: false,
        //                 info: 'Стръмен наклон при изкачване'
        //             },
        //             {
        //                 id: 7,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А7',
        //                 image: a7_1,
        //                 swichdOn: false,
        //                 info: 'Платно за движение, стеснено от двете страни'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А8',
        //                 image: a8_1,
        //                 swichdOn: false,
        //                 info: 'Платно за движение, стеснено отдясно'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А9',
        //                 image: a9_1,
        //                 swichdOn: false,
        //                 info: 'Платно за движение, стеснено отляво'
        //             },
        //             {
        //                 id: 10,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А10',
        //                 image: a10_1,
        //                 swichdOn: false,
        //                 info: 'Подвижен мост или ферибот'
        //             },
        //             {
        //                 id: 11,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А11',
        //                 image: a11_1,
        //                 swichdOn: false,
        //                 info: 'Пътят води до кей или бряг'
        //             },
        //             {
        //                 id: 12,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А12',
        //                 image: a12_1,
        //                 swichdOn: false,
        //                 info: 'Неравности по платното за движение'
        //             },
        //             {
        //                 id: 13,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А13',
        //                 image: a13_1,
        //                 swichdOn: false,
        //                 info: 'Изкуствени неравности по платното за движение'
        //             },
        //             {
        //                 id: 14,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А14',
        //                 image: a14_1,
        //                 swichdOn: false,
        //                 info: 'Опасен пътен банкет'
        //             },
        //             {
        //                 id: 15,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А15',
        //                 image: a15_1,
        //                 swichdOn: false,
        //                 info: 'Опасност от хлъзгане'
        //             },
        //             {
        //                 id: 16,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А16',
        //                 image: a16_1,
        //                 swichdOn: false,
        //                 info: 'Възможно е изхвърляне на малки камъни'
        //             },
        //             {
        //                 id: 17,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А17',
        //                 image: a17_1,
        //                 swichdOn: false,
        //                 info: 'Опасност от срутване или наличие на паднали камъни'
        //             },
        //             {
        //                 id: 18,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А18',
        //                 image: a18_1,
        //                 swichdOn: false,
        //                 info: 'Пешеходна пътека'
        //             },
        //             {
        //                 id: 19,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А19',
        //                 image: a19_1,
        //                 swichdOn: false,
        //                 info: 'Деца'
        //             },
        //             {
        //                 id: 20,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А20',
        //                 image: a20_1,
        //                 swichdOn: false,
        //                 info: 'Велосипедисти'
        //             },
        //             {
        //                 id: 21,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А21',
        //                 image: a21_1,
        //                 swichdOn: false,
        //                 info: 'Възможна е поява на домашни животни'
        //             },
        //             {
        //                 id: 22,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А22',
        //                 image: a22_1,
        //                 swichdOn: false,
        //                 info: 'Възможна е поява на диви животни'
        //             },
        //             {
        //                 id: 23,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А23',
        //                 image: a23_1,
        //                 swichdOn: false,
        //                 info: 'Участък от пътя в ремонт'
        //             },
        //             {
        //                 id: 24,
        //                 posterId: '124c340d',
        //                 name: 'Пътен знак А24',
        //                 image: a24_1,
        //                 swichdOn: false,
        //                 info: 'Светофар'
        //             },

        //             {
        //                 id: 1,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А25',
        //                 image: a25_2,
        //                 swichdOn: false,
        //                 info: 'Кръстовище на равнозначни пътища'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А26',
        //                 image: a26_2,
        //                 swichdOn: false,
        //                 info: 'Кръстовище с път без предимство'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А27',
        //                 image: a27_2,
        //                 swichdOn: false,
        //                 info: 'Кръстовище с път без предимство отдясно'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А28',
        //                 image: a28_2,
        //                 swichdOn: false,
        //                 info: 'Кръстовище с път без предимство отляво'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А29',
        //                 image: a29_2,
        //                 swichdOn: false,
        //                 info: 'Кръстовище с кръгово движение'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А30',
        //                 image: a30_2,
        //                 swichdOn: false,
        //                 info: 'Двупосочно движение'
        //             },
        //             {
        //                 id: 7,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А31',
        //                 image: a31_2,
        //                 swichdOn: false,
        //                 info: 'Пресичане на трамвайна линия'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А32',
        //                 image: a32_2,
        //                 swichdOn: false,
        //                 info: 'Железопътен прелез с бариери'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А33',
        //                 image: a33_2,
        //                 swichdOn: false,
        //                 info: 'Железопътен прелез без бариери'
        //             },
        //             {
        //                 id: 10,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А34.1',
        //                 image: a34_2,
        //                 swichdOn: false,
        //                 info: 'Железопътен прелез с един коловоз'
        //             },
        //             {
        //                 id: 11,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А34.2',
        //                 image: a35_2,
        //                 swichdOn: false,
        //                 info: 'Железопътен прелез с два и повече коловоза'
        //             },
        //             {
        //                 id: 12,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А35',
        //                 image: a36_2,
        //                 swichdOn: false,
        //                 info: 'Бализ'
        //             },
        //             {
        //                 id: 13,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А36',
        //                 image: a37_2,
        //                 swichdOn: false,
        //                 info: 'Възможно е ниско прелитане на самолети'
        //             },
        //             {
        //                 id: 14,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А37',
        //                 image: a38_2,
        //                 swichdOn: false,
        //                 info: 'Възможна е поява на силен страничен вятър'
        //             },
        //             {
        //                 id: 15,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А38',
        //                 image: a39_2,
        //                 swichdOn: false,
        //                 info: 'Тунел'
        //             },
        //             {
        //                 id: 16,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А39',
        //                 image: a40_2,
        //                 swichdOn: false,
        //                 info: 'Внимание! Други опасности'
        //             },
        //             {
        //                 id: 17,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А40',
        //                 image: a41_2,
        //                 swichdOn: false,
        //                 info: 'Внимание! Участък с концентрация на пътнотранспортни произшествия'
        //             },
        //             {
        //                 id: 18,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А41',
        //                 image: a42_2,
        //                 swichdOn: false,
        //                 info: 'Образуване на задръстване'
        //             },
        //             {
        //                 id: 19,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А42',
        //                 image: a43_2,
        //                 swichdOn: false,
        //                 info: 'Намалена видимост'
        //             },
        //             {
        //                 id: 20,
        //                 posterId: '124c357d',
        //                 name: 'Пътен знак А43',
        //                 image: a44_2,
        //                 swichdOn: false,
        //                 info: 'Настъпило пътнотранспортно произшествие'
        //             },
        //         ]
        //     },
        //     {
        //         id: 2,
        //         name: 'Група Б',
        //         icon: groupBIcon,
        //         isSign: true,
        //         allSwichedOn: false,
        //         signals: [
        //             {
        //                 id: 1,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак Б1',
        //                 image: b1_3,
        //                 swichdOn: false,
        //                 info: 'Пропусни движещите се по пътя с предимство!'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак Б2',
        //                 image: b2_3,
        //                 swichdOn: false,
        //                 info: 'Спри! Пропусни движещите се по пътя с предимство!'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак Б3',
        //                 image: b3_3,
        //                 swichdOn: false,
        //                 info: 'Път с предимство'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак Б4',
        //                 image: b4_3,
        //                 swichdOn: false,
        //                 info: 'Край на пътя с предимство'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак Б5',
        //                 image: b5_3,
        //                 swichdOn: false,
        //                 info: 'Пропусни насрещно движещите се пътни превозни средства!'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак Б6',
        //                 image: b6_3,
        //                 swichdOn: false,
        //                 info: 'Премини, ако пътят е свободен!'
        //             },

        //         ]
        //     },
        //     {
        //         id: 3,
        //         name: 'Група В',
        //         icon: groupVIcon,
        //         isSign: true,
        //         allSwichedOn: false,
        //         signals: [
        //             {
        //                 id: 7,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В1',
        //                 image: v1_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на пътни превозни средства'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В2',
        //                 image: v2_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на пътни превозни средства в двете посоки'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В3',
        //                 image: v3_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на моторни превозни средства, с изключение на мотоциклети без кош и мотопеди'
        //             },
        //             {
        //                 id: 10,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В4',
        //                 image: v4_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на товарни автомобили'
        //             },
        //             {
        //                 id: 11,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В5',
        //                 image: v5_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на моторни превозни средства с ремаркета, освен с полуремаркета или единични едноосни ремаркета'
        //             },
        //             {
        //                 id: 12,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В6',
        //                 image: v6_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на моторни превозни средства с ремаркета'
        //             },
        //             {
        //                 id: 13,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В7',
        //                 image: v7_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на трактори и самоходни машини'
        //             },
        //             {
        //                 id: 14,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В8',
        //                 image: v8_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на мотоциклети и мотопеди'
        //             },
        //             {
        //                 id: 15,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В9',
        //                 image: v9_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на велосипеди'
        //             },
        //             {
        //                 id: 16,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В10',
        //                 image: v10_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на пътни превозни средства, теглени от животни'
        //             },
        //             {
        //                 id: 17,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В11',
        //                 image: v11_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на колички за превоз на товари, теглени или бутани от хора'
        //             },
        //             {
        //                 id: 18,
        //                 posterId: '124c3599',
        //                 name: 'Пътен знак В12',
        //                 image: v12_3,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на пешеходци'
        //             },
        //             {
        //                 id: 1,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В13',
        //                 image: v13_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на пътни превозни средства, превозващи опасни товари'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В14',
        //                 image: v14_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на изобразените пътни превозни средства'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В15',
        //                 image: v15_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на пътни превозни средства с широчина, включително и товара, по-голяма от означената'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В16',
        //                 image: v16_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на пътни превозни средства с височина, включително и товара, по-голяма от означената'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В17',
        //                 image: v17_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на пътни превозни средства или състав от пътни превозни средства с дължина, включително и товара, по-голяма от означената'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В18',
        //                 image: v18_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на пътни превозни средства с маса с товар, по-голяма от означената'
        //             },
        //             {
        //                 id: 7,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В19',
        //                 image: v19_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е влизането на пътни превозни средства с натоварване на която и да е от осите, по-голямо от означеното'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В20',
        //                 image: v20_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е движението на пътни превозни средства едно след друго на разстояние, по-малко от означеното'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В21',
        //                 image: v21_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е завиването надясно'
        //             },
        //             {
        //                 id: 10,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В22',
        //                 image: v22_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е завиването наляво'
        //             },
        //             {
        //                 id: 11,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В23',
        //                 image: v23_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е завиването в обратна посока'
        //             },
        //             {
        //                 id: 12,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В24',
        //                 image: v24_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е изпреварването на автомобили и мотоциклети с кош'
        //             },
        //             {
        //                 id: 13,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В25',
        //                 image: v25_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е изпреварването на автомобили и мотоциклети с кош от товарни автомобили с максимално допустима маса над 3,5 тона'
        //             },
        //             {
        //                 id: 14,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В26',
        //                 image: v26_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е движение със скорост, по-висока от означената'
        //             },
        //             {
        //                 id: 15,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В27',
        //                 image: v27_4,
        //                 swichdOn: false,
        //                 info: 'Забранени са престоят и паркирането'
        //             },
        //             {
        //                 id: 16,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В28',
        //                 image: v28_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е паркирането'
        //             },
        //             {
        //                 id: 17,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В29',
        //                 image: v29_4,
        //                 swichdOn: false,
        //                 info: 'Забранено е преминаването без спиране (Попр. - ДВ, бр. 72 от 1996 г.)'
        //             },
        //             {
        //                 id: 18,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В30',
        //                 image: v30_4,
        //                 swichdOn: false,
        //                 info: 'Забранена е употребата на звуков сигнал'
        //             },
        //             {
        //                 id: 19,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В31',
        //                 image: v31_4,
        //                 swichdOn: false,
        //                 info: 'Край на въведената с пътен знак забрана за изпреварване на автомобили и мотоциклети с кош'
        //             },
        //             {
        //                 id: 20,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В32',
        //                 image: v32_4,
        //                 swichdOn: false,
        //                 info: 'Край на въведената с пътен знак забрана за изпреварване от товарни автомобили с максимално допустима маса над 3,5 тона'
        //             },
        //             {
        //                 id: 21,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В33',
        //                 image: v33_4,
        //                 swichdOn: false,
        //                 info: 'Край на въведената с пътен знак забрана за движение със скорост, по-висока от означената'
        //             },
        //             {
        //                 id: 22,
        //                 posterId: '124c33ed',
        //                 name: 'Пътен знак В34',
        //                 image: v34_4,
        //                 swichdOn: false,
        //                 info: 'Край на забраните, въведени с пътни знаци'
        //             },
        //         ]
        //     },
        //     {
        //         id: 4,
        //         name: 'Група Г',
        //         icon: groupGIcon,
        //         isSign: true,
        //         allSwichedOn: false,
        //         signals: [
        //             {
        //                 id: 1,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г1',
        //                 image: g1_5,
        //                 swichdOn: false,
        //                 info: 'Движение само направо след знака'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г2',
        //                 image: g2_5,
        //                 swichdOn: false,
        //                 info: 'Движение само надясно след знака'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г3',
        //                 image: g3_5,
        //                 swichdOn: false,
        //                 info: 'Движение само наляво след знака'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г4',
        //                 image: g4_5,
        //                 swichdOn: false,
        //                 info: 'Движение само направо или надясно след знака'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г5',
        //                 image: g5_5,
        //                 swichdOn: false,
        //                 info: 'Движение само направо или наляво след знака'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г6',
        //                 image: g6_5,
        //                 swichdOn: false,
        //                 info: 'Движение само надясно или наляво след знака'
        //             },
        //             {
        //                 id: 7,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г7',
        //                 image: g7_5,
        //                 swichdOn: false,
        //                 info: 'Движение само надясно пред знака'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г8',
        //                 image: g8_5,
        //                 swichdOn: false,
        //                 info: 'Движение само наляво пред знака'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г9',
        //                 image: g9_5,
        //                 swichdOn: false,
        //                 info: 'Преминаване отдясно на знака'
        //             },
        //             {
        //                 id: 10,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г10',
        //                 image: g10_5,
        //                 swichdOn: false,
        //                 info: 'Преминаване отляво на знака'
        //             },
        //             {
        //                 id: 11,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г11',
        //                 image: g11_5,
        //                 swichdOn: false,
        //                 info: 'Преминаване отдясно или отляво на знака'
        //             },
        //             {
        //                 id: 12,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г12',
        //                 image: g12_5,
        //                 swichdOn: false,
        //                 info: 'Кръгово движение'
        //             },
        //             {
        //                 id: 13,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г13',
        //                 image: g13_5,
        //                 swichdOn: false,
        //                 info: 'Пътна лента или платно за движение само на превозни средства от редовните линии за обществен превоз на пътници'
        //             },
        //             {
        //                 id: 14,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г14',
        //                 image: g14_5,
        //                 swichdOn: false,
        //                 info: 'Задължителен път само за велосипедисти'
        //             },
        //             {
        //                 id: 15,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г15',
        //                 image: g15_5,
        //                 swichdOn: false,
        //                 info: 'Задължителен път само за пешеходци'
        //             },
        //             {
        //                 id: 16,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г16',
        //                 image: g16_5,
        //                 swichdOn: false,
        //                 info: 'Задължителен път само за пешеходци и велосипедисти'
        //             },
        //             {
        //                 id: 17,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г17',
        //                 image: g17_5,
        //                 swichdOn: false,
        //                 info: 'Задължителна минимална скорост'
        //             },
        //             {
        //                 id: 18,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г18',
        //                 image: g18_5,
        //                 swichdOn: false,
        //                 info: 'Край на задължителната минимална скорост'
        //             },
        //             {
        //                 id: 19,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г19',
        //                 image: g19_5,
        //                 swichdOn: false,
        //                 info: 'Задължителни вериги за сняг най-малко на две от двигателните колела'
        //             },
        //             {
        //                 id: 20,
        //                 posterId: '124c33f5',
        //                 name: 'Пътен знак Г20',
        //                 image: g20_5,
        //                 swichdOn: false,
        //                 info: 'Задължителна посока за движение на пътни превозни средства, превозващи опасни товари'
        //             },
        //         ]
        //     },
        //     {
        //         id: 5,
        //         name: 'Група Д',
        //         icon: groupDIcon,
        //         isSign: true,
        //         allSwichedOn: false,
        //         signals: [
        //             {
        //                 id: 1,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д1',
        //                 image: d1_6,
        //                 swichdOn: false,
        //                 info: 'Брой на пътните ленти и посоки за движение по тях'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д2',
        //                 image: d2_6,
        //                 swichdOn: false,
        //                 info: 'Допълнителна пътна лента за бавнодвижещи се пътни превозни средства'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д3',
        //                 image: d3_6,
        //                 swichdOn: false,
        //                 info: 'Указател за предварително престрояване'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д4',
        //                 image: d4_6,
        //                 swichdOn: false,
        //                 info: 'Еднопосочно движение след знака'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д5',
        //                 image: d5_6,
        //                 swichdOn: false,
        //                 info: 'Автомагистрала'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д6',
        //                 image: d6_6,
        //                 swichdOn: false,
        //                 info: 'Край на автомагистралата'
        //             },
        //             {
        //                 id: 7,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д7',
        //                 image: d7_6,
        //                 swichdOn: false,
        //                 info: 'Автомобилен път'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д7а',
        //                 image: d8_6,
        //                 swichdOn: false,
        //                 info: 'Скоростен път'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д8',
        //                 image: d9_6,
        //                 swichdOn: false,
        //                 info: 'Край на автомобилния път'
        //             },
        //             {
        //                 id: 10,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д8а',
        //                 image: d10_6,
        //                 swichdOn: false,
        //                 info: 'Край на скоростния път'
        //             },
        //             {
        //                 id: 11,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д9',
        //                 image: d11_6,
        //                 swichdOn: false,
        //                 info: 'Тунел'
        //             },
        //             {
        //                 id: 12,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д10',
        //                 image: d12_6,
        //                 swichdOn: false,
        //                 info: 'Край на тунела'
        //             },
        //             {
        //                 id: 13,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д11',
        //                 image: d13_6,
        //                 swichdOn: false,
        //                 info: 'Начало на населено място'
        //             },
        //             {
        //                 id: 14,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д12',
        //                 image: d14_6,
        //                 swichdOn: false,
        //                 info: 'Край на населеното място'
        //             },
        //             {
        //                 id: 15,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д13',
        //                 image: d15_6,
        //                 swichdOn: false,
        //                 info: 'Начало на зоната на действие на изобразения пътен знак'
        //             },
        //             {
        //                 id: 16,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д14',
        //                 image: d16_6,
        //                 swichdOn: false,
        //                 info: 'Край на зоната на действие на изобразения пътен знак'
        //             },
        //             {
        //                 id: 17,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д15',
        //                 image: d17_6,
        //                 swichdOn: false,
        //                 info: 'Начало на жилищна зона'
        //             },
        //             {
        //                 id: 18,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д16',
        //                 image: d18_6,
        //                 swichdOn: false,
        //                 info: 'Край на жилищната зона'
        //             },
        //             {
        //                 id: 19,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д17',
        //                 image: d19_6,
        //                 swichdOn: false,
        //                 info: 'Пешеходна пътека'
        //             },
        //             {
        //                 id: 20,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д18',
        //                 image: d20_6,
        //                 swichdOn: false,
        //                 info: 'Болница'
        //             },
        //             {
        //                 id: 21,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д19',
        //                 image: d21_6,
        //                 swichdOn: false,
        //                 info: 'Паркинг'
        //             },
        //             {
        //                 id: 22,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д20',
        //                 image: d22_6,
        //                 swichdOn: false,
        //                 info: 'Платен паркинг'
        //             },
        //             {
        //                 id: 23,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д21',
        //                 image: d23_6,
        //                 swichdOn: false,
        //                 info: 'Място за паркиране на пътни превозни средства, обслужващи хора с увреждания'
        //             },
        //             {
        //                 id: 24,
        //                 posterId: '124c3591',
        //                 name: 'Пътен знак Д22',
        //                 image: d24_6,
        //                 swichdOn: false,
        //                 info: 'Трамвайна спирка'
        //             },

        //             {
        //                 id: 1,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Д23',
        //                 image: d25_7,
        //                 swichdOn: false,
        //                 info: 'Тролейбусна спирка'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Д24',
        //                 image: d26_7,
        //                 swichdOn: false,
        //                 info: 'Автобусна спирка'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Д25',
        //                 image: d27_7,
        //                 swichdOn: false,
        //                 info: 'За използване на пътя се изисква платена винетна такса'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Д25.1',
        //                 image: d28_7,
        //                 swichdOn: false,
        //                 info: 'Сигнализира за участък, за използването на който се изисква платена винетна или тол такса'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Д25.2',
        //                 image: d29_7,
        //                 swichdOn: false,
        //                 info: 'Указва, че за използването на пътя се изисква платена тол такса'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Д26',
        //                 image: d30_7,
        //                 swichdOn: false,
        //                 info: 'Място за паркиране на електрически превозни средства за зареждане'
        //             },
        //         ]
        //     },
        //     {
        //         id: 6,
        //         name: 'Група Е',
        //         icon: groupEIcon,
        //         isSign: true,
        //         allSwichedOn: false,
        //         signals: [
        //             {
        //                 id: 7,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е1',
        //                 image: e1_7,
        //                 swichdOn: false,
        //                 info: 'Медицински пункт'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е2',
        //                 image: e2_7,
        //                 swichdOn: false,
        //                 info: 'Болница със звено за спешна медицинска помощ'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е3',
        //                 image: e3_7,
        //                 swichdOn: false,
        //                 info: 'Полиция'
        //             },
        //             {
        //                 id: 10,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е4',
        //                 image: e4_7,
        //                 swichdOn: false,
        //                 info: 'Телефон'
        //             },
        //             {
        //                 id: 11,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е5',
        //                 image: e5_7,
        //                 swichdOn: false,
        //                 info: 'Автосервиз'
        //             },
        //             {
        //                 id: 12,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е6',
        //                 image: e6_7,
        //                 swichdOn: false,
        //                 info: 'Автомивка'
        //             },
        //             {
        //                 id: 14,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е7',
        //                 image: e7_7,
        //                 swichdOn: false,
        //                 info: 'Бензиностанция'
        //             },
        //             {
        //                 id: 13,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е8',
        //                 image: e8_7,
        //                 swichdOn: false,
        //                 info: 'Информационно бюро за туристи'
        //             },
        //             {
        //                 id: 15,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е9',
        //                 image: e9_7,
        //                 swichdOn: false,
        //                 info: 'Хотел или мотел'
        //             },
        //             {
        //                 id: 16,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е10',
        //                 image: e10_7,
        //                 swichdOn: false,
        //                 info: 'Ресторант'
        //             },
        //             {
        //                 id: 17,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е11',
        //                 image: e11_7,
        //                 swichdOn: false,
        //                 info: 'Кафе'
        //             },
        //             {
        //                 id: 18,
        //                 posterId: '124c3581',
        //                 name: 'Пътен знак Е12',
        //                 image: e12_7,
        //                 swichdOn: false,
        //                 info: 'Къмпинг за палатки'
        //             },

        //             {
        //                 id: 1,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е13',
        //                 image: e13_8,
        //                 swichdOn: false,
        //                 info: 'Къмпинг за туристически ремаркета'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е14',
        //                 image: e14_8,
        //                 swichdOn: false,
        //                 info: 'Къмпинг за палатки и туристически ремаркета'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е15',
        //                 image: e15_8,
        //                 swichdOn: false,
        //                 info: 'Туристическа база'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е16',
        //                 image: e16_8,
        //                 swichdOn: false,
        //                 info: 'Място за отдих'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е17',
        //                 image: e17_8,
        //                 swichdOn: false,
        //                 info: 'Начало на пешеходен маршрут'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е18',
        //                 image: e18_8,
        //                 swichdOn: false,
        //                 info: 'Вода за пиене'
        //             },
        //             {
        //                 id: 7,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е19',
        //                 image: e19_8,
        //                 swichdOn: false,
        //                 info: 'Тоалетна'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е20',
        //                 image: e20_8,
        //                 swichdOn: false,
        //                 info: 'Такси'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е21',
        //                 image: e21_8,
        //                 swichdOn: false,
        //                 info: 'Пешеходен подлез или надлез'
        //             },
        //             {
        //                 id: 10,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е22',
        //                 image: e22_8,
        //                 swichdOn: false,
        //                 info: 'Допустими максимални скорости на движение'
        //             },
        //             {
        //                 id: 11,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е23',
        //                 image: e23_8,
        //                 swichdOn: false,
        //                 info: 'Проходът е отворен или затворен за движение'
        //             },
        //             {
        //                 id: 12,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е24',
        //                 image: e24_8,
        //                 swichdOn: false,
        //                 info: 'Контрол с автоматизирани технически средства или системи'
        //             },
        //             {
        //                 id: 13,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е25',
        //                 image: e25_8,
        //                 swichdOn: false,
        //                 info: 'Зарядна станция за зареждане на електрически превозни средства'
        //             },
        //             {
        //                 id: 14,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Е26',
        //                 image: e26_8,
        //                 swichdOn: false,
        //                 info: 'Зарядна станция за зареждане с водород'
        //             },
        //         ]
        //     },
        //     {
        //         id: 7,
        //         name: 'Група Ж',
        //         icon: groupJIcon,
        //         isSign: true,
        //         allSwichedOn: false,
        //         signals: [
        //             {
        //                 id: 15,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Ж1',
        //                 image: j1_8,
        //                 swichdOn: false,
        //                 info: 'Предварителен указател'
        //             },
        //             {
        //                 id: 16,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Ж2',
        //                 image: j2_8,
        //                 swichdOn: false,
        //                 info: 'Предварително указване на посока към населено място или обект'
        //             },
        //             {
        //                 id: 17,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Ж3',
        //                 image: j3_8,
        //                 swichdOn: false,
        //                 info: 'Предварителен указател за отклоняване на движението'
        //             },
        //             {
        //                 id: 18,
        //                 posterId: '124c35ed',
        //                 name: 'Пътен знак Ж4',
        //                 image: j4_8,
        //                 swichdOn: false,
        //                 info: 'Предварителен указател за завиване'
        //             },

        //             {
        //                 id: 1,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж5',
        //                 image: j5_9,
        //                 swichdOn: false,
        //                 info: 'Предварителен указател за посоката на движение на означения вид пътни превозни средства'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж6',
        //                 image: j6_9,
        //                 swichdOn: false,
        //                 info: 'Указателна табела'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж7',
        //                 image: j7_9,
        //                 swichdOn: false,
        //                 info: 'Указателна стрелка'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж8',
        //                 image: j8_9,
        //                 swichdOn: false,
        //                 info: 'Посока към ферибот'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж9',
        //                 image: j9_9,
        //                 swichdOn: false,
        //                 info: 'Място за завиване в обратна посока'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж10',
        //                 image: j10_9,
        //                 swichdOn: false,
        //                 info: 'Потвърждаване на посоката към населено място'
        //             },
        //             {
        //                 id: 7,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж11',
        //                 image: j11_9,
        //                 swichdOn: false,
        //                 info: 'Наименование на обект'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж12',
        //                 image: j12_9,
        //                 swichdOn: false,
        //                 info: 'Пресичаният път е без изход'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж13',
        //                 image: j13_9,
        //                 swichdOn: false,
        //                 info: 'Път без изход'
        //             },
        //             {
        //                 id: 10,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж14',
        //                 image: j14_9,
        //                 swichdOn: false,
        //                 info: 'Начало на пътна лента'
        //             },
        //             {
        //                 id: 11,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж15',
        //                 image: j15_9,
        //                 swichdOn: false,
        //                 info: 'Край на пътна лента'
        //             },
        //             {
        //                 id: 12,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж16',
        //                 image: j16_9,
        //                 swichdOn: false,
        //                 info: 'Преминаване в платното за насрещно движение'
        //             },
        //             {
        //                 id: 13,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж18',
        //                 image: j17_9,
        //                 swichdOn: false,
        //                 info: 'Пътна лента със съоръжение за аварийно спиране'
        //             },
        //             {
        //                 id: 14,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж19',
        //                 image: j18_9,
        //                 swichdOn: false,
        //                 info: 'Препоръчителна скорост'
        //             },
        //             {
        //                 id: 15,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж20.1',
        //                 image: j19_9,
        //                 swichdOn: false,
        //                 info: 'Номер на автомагистралата по националната класификация'
        //             },
        //             {
        //                 id: 16,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж20.2',
        //                 image: j20_9,
        //                 swichdOn: false,
        //                 info: 'Номер на пътя по националната класификация'
        //             },
        //             {
        //                 id: 17,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж21',
        //                 image: j21_9,
        //                 swichdOn: false,
        //                 info: 'Номер на пътя по международната класификация'
        //             },
        //             {
        //                 id: 18,
        //                 posterId: '124c35d5',
        //                 name: 'Пътен знак Ж22',
        //                 image: j22_9,
        //                 swichdOn: false,
        //                 info: 'Километричен знак'
        //             },
        //         ]
        //     },
        //     {
        //         id: 8,
        //         name: 'Група Т',
        //         icon: groupTIcon,
        //         isSign: true,
        //         allSwichedOn: false,
        //         signals: [
        //             {
        //                 id: 1,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т1',
        //                 image: t1_10,
        //                 swichdOn: false,
        //                 info: 'Разстояние до'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т2',
        //                 image: t2_10,
        //                 swichdOn: false,
        //                 info: 'Дължина на'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т3',
        //                 image: t3_10,
        //                 swichdOn: false,
        //                 info: 'Начало на зоната на действие на пътни знаци В27 и В28'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т3',
        //                 image: t4_10,
        //                 swichdOn: false,
        //                 info: 'Начало на зоната на действие на пътни знаци В27 и В28'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т4',
        //                 image: t5_10,
        //                 swichdOn: false,
        //                 info: 'Продължаване зоната на действие на пътни знаци В27 и В28'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т4',
        //                 image: t6_10,
        //                 swichdOn: false,
        //                 info: 'Продължаване зоната на действие на пътни знаци В27 и В28'
        //             },
        //             {
        //                 id: 7,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т5',
        //                 image: t7_10,
        //                 swichdOn: false,
        //                 info: 'Край на зоната на действие на пътни знаци В27 и В28'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т5',
        //                 image: t8_10,
        //                 swichdOn: false,
        //                 info: 'Край на зоната на действие на пътни знаци В27 и В28'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т6',
        //                 image: t9_10,
        //                 swichdOn: false,
        //                 info: 'Пътно превозно средство, за което се отнася действието на пътния знак'
        //             },
        //             {
        //                 id: 10,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т7',
        //                 image: t10_10,
        //                 swichdOn: false,
        //                 info: 'Пътно превозно средство, за което не се отнася действието на пътния знак'
        //             },
        //             {
        //                 id: 11,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т8',
        //                 image: t11_10,
        //                 swichdOn: false,
        //                 info: 'Разстояние до пътен знак Б2'
        //             },
        //             {
        //                 id: 12,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т9',
        //                 image: t12_10,
        //                 swichdOn: false,
        //                 info: 'Стрелка'
        //             },
        //             {
        //                 id: 13,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т10',
        //                 image: t13_10,
        //                 swichdOn: false,
        //                 info: 'Време на действие на пътния знак'
        //             },
        //             {
        //                 id: 14,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т11',
        //                 image: t14_10,
        //                 swichdOn: false,
        //                 info: 'Посока към обект'
        //             },
        //             {
        //                 id: 15,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т12',
        //                 image: t15_10,
        //                 swichdOn: false,
        //                 info: 'Начин на паркиране на пътните превозни средства'
        //             },
        //             {
        //                 id: 16,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т13',
        //                 image: t16_10,
        //                 swichdOn: false,
        //                 info: 'Направление на пътя с предимство в кръстовището'
        //             },
        //             {
        //                 id: 17,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т14',
        //                 image: t17_10,
        //                 swichdOn: false,
        //                 info: 'При сняг и зимни условия'
        //             },
        //             {
        //                 id: 18,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т14.1',
        //                 image: t18_10,
        //                 swichdOn: false,
        //                 info: 'При дъжд и мокра настилка'
        //             },
        //             {
        //                 id: 19,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т15',
        //                 image: t19_10,
        //                 swichdOn: false,
        //                 info: 'Работни дни'
        //             },
        //             {
        //                 id: 20,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т16',
        //                 image: t20_10,
        //                 swichdOn: false,
        //                 info: 'Неработни дни'
        //             },
        //             {
        //                 id: 21,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т17',
        //                 image: t21_10,
        //                 swichdOn: false,
        //                 info: 'Табела с текст'
        //             },
        //             {
        //                 id: 22,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т18.1',
        //                 image: t22_10,
        //                 swichdOn: false,
        //                 info: 'Принудително отстраняване на МПС'
        //             },
        //             {
        //                 id: 23,
        //                 posterId: '124c35e9',
        //                 name: 'Пътен знак Т18.2',
        //                 image: t23_10,
        //                 swichdOn: false,
        //                 info: 'Поставяне на ограничителни средства'
        //             },
        //         ]
        //     },
        //     {
        //         id: 9,
        //         name: 'СРЕДСТВА ЗА СИГНАЛИЗАЦИЯ',
        //         icon: signalMethodsIcon,
        //         isSign: false,
        //         allSwichedOn: false,
        //         signals: [
        //             {
        //                 id: 1,
        //                 posterId: '124c3401',
        //                 name: 'С1',
        //                 image: sm1_13,
        //                 swichdOn: false,
        //                 info: 'Направляващо стълбче'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c3401',
        //                 name: 'С2',
        //                 image: sm2_13,
        //                 swichdOn: false,
        //                 info: 'Конус'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c3401',
        //                 name: 'С3.1',
        //                 image: sm3_13,
        //                 swichdOn: false,
        //                 info: 'Бариера'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c3401',
        //                 name: 'С3.2',
        //                 image: sm4_13,
        //                 swichdOn: false,
        //                 info: 'Въже с червени флагчета или червени светлоотразителни елементи'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c3401',
        //                 name: 'С3.3',
        //                 image: sm5_13,
        //                 swichdOn: false,
        //                 info: 'Пастмасова лента, оцветена ярко или с успоредни червени и бели ивици'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c3401',
        //                 name: 'С4',
        //                 image: sm6_13,
        //                 swichdOn: false,
        //                 info: 'Ограничителна табела'
        //             },
        //             {
        //                 id: 7,
        //                 posterId: '124c3401',
        //                 name: 'С5',
        //                 image: sm7_13,
        //                 swichdOn: false,
        //                 info: 'Устройство за отчитане на времетраенето на светлинния сигнал'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c3401',
        //                 name: 'С6.1',
        //                 image: sm8_13,
        //                 swichdOn: false,
        //                 info: 'Табела с направляващи стрелки'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c3401',
        //                 name: 'С7',
        //                 image: sm9_13,
        //                 swichdOn: false,
        //                 info: 'Табела с направляваща стрелка'
        //             },
        //             {
        //                 id: 10,
        //                 posterId: '124c3401',
        //                 name: 'С8',
        //                 image: sm10_13,
        //                 swichdOn: false,
        //                 info: 'Стоп-палка'
        //             },
        //             {
        //                 id: 11,
        //                 posterId: '124c3401',
        //                 name: 'С9',
        //                 image: sm11_13,
        //                 swichdOn: false,
        //                 info: 'Регулировъчна палка'
        //             },
        //             {
        //                 id: 12,
        //                 posterId: '124c3401',
        //                 name: 'С10',
        //                 image: sm12_13,
        //                 swichdOn: false,
        //                 info: 'Палка "Стоп! Деца"'
        //             },
        //             {
        //                 id: 13,
        //                 posterId: '124c3401',
        //                 name: 'С11.1',
        //                 image: sm13_13,
        //                 swichdOn: false,
        //                 info: 'Бял бастун'
        //             },
        //             {
        //                 id: 14,
        //                 posterId: '124c3401',
        //                 name: 'С11.2',
        //                 image: sm14_13,
        //                 swichdOn: false,
        //                 info: 'Бяла лента с точки'
        //             },
        //             {
        //                 id: 15,
        //                 posterId: '124c3401',
        //                 name: 'С12',
        //                 image: sm15_13,
        //                 swichdOn: false,
        //                 info: 'Отличителен знак на лицата, извършващи работа на пътя'
        //             },
        //             {
        //                 id: 16,
        //                 posterId: '124c3401',
        //                 name: 'С13',
        //                 image: sm16_13,
        //                 swichdOn: false,
        //                 info: 'Предупредителен светлоотразителен триъгълник'
        //             },
        //             {
        //                 id: 17,
        //                 posterId: '124c3401',
        //                 name: 'С14',
        //                 image: sm17_13,
        //                 swichdOn: false,
        //                 info: 'Светлоотразител'
        //             },
        //             {
        //                 id: 18,
        //                 posterId: '124c3401',
        //                 name: 'С15',
        //                 image: sm18_13,
        //                 swichdOn: false,
        //                 info: 'Светлоотразяващи кабари'
        //             },
        //             {
        //                 id: 19,
        //                 posterId: '124c3401',
        //                 name: 'С16',
        //                 image: sm19_13,
        //                 swichdOn: false,
        //                 info: 'Светлинен източник, подаващ жълта мигаща светлина'
        //             },
        //             {
        //                 id: 20,
        //                 posterId: '124c3401',
        //                 name: 'С17',
        //                 image: sm20_13,
        //                 swichdOn: false,
        //                 info: 'Преносими светофарни уредби с три секционни светофара'
        //             },
        //             {
        //                 id: 21,
        //                 posterId: '124c3401',
        //                 name: 'С18',
        //                 image: sm21_13,
        //                 swichdOn: false,
        //                 info: 'предупредителен флаг'
        //             },
        //             {
        //                 id: 22,
        //                 posterId: '124c3401',
        //                 name: 'С19',
        //                 image: sm22_13,
        //                 swichdOn: false,
        //                 info: 'Затваряща табела – със или без светлини'
        //             },
        //             {
        //                 id: 23,
        //                 posterId: '124c3401',
        //                 name: 'С20',
        //                 image: sm23_13,
        //                 swichdOn: false,
        //                 info: 'Преносима стойка с пътни знаци'
        //             },
        //             {
        //                 id: 24,
        //                 posterId: '124c3401',
        //                 name: 'Електронен пътен знак',
        //                 image: sm24_13,
        //                 swichdOn: false,
        //                 info: 'Светеща информационна табела'
        //             },
        //         ]
        //     },
        //     {
        //         id: 10,
        //         name: 'РЕГУЛИРОВЧИЦИ',
        //         icon: trafficPoliceIcon,
        //         isSign: false,
        //         allSwichedOn: false,
        //         signals: [
        //             {
        //                 id: 1,
        //                 posterId: '124c33f1',
        //                 name: 'Разрешаващ сигнал',
        //                 image: tp2_12,
        //                 swichdOn: false,
        //                 info: 'Сигнал подаден с ръка или ръце, протегнати хоризонталновстрани, означава че „ПРЕМИНАВАНЕТО Е РАЗРЕШЕНО“'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c33f1',
        //                 name: 'Разрешаващ сигнал',
        //                 image: tp1_12,
        //                 swichdOn: false,
        //                 info: 'Сигнал подаден с протегната дясна ръкахоризонтално напред, означава че „ПРЕМИНАВАНЕТО Е РАЗРЕШЕНО“ във всички посоки, включително и обратен завой '
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c33f1',
        //                 name: 'Внимание спри!',
        //                 image: tp3_12,
        //                 swichdOn: false,
        //                 info: 'Следващият сигнал с дясна ръка вдигната вертикално нагореозначава „ВНИМАНИЕ, СПРИ!“'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c33f1',
        //                 name: 'Забраняващ сигнал',
        //                 image: tp4_12,
        //                 swichdOn: false,
        //                 info: 'Преминаването е забранено на водачите на пътни превозни средства винаги, когато приближават регулировчика пред гърди или зад гърба му.'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c33f1',
        //                 name: 'Забраняващ сигнал',
        //                 image: tp5_12,
        //                 swichdOn: false,
        //                 info: 'Преминаването е забранено на водачите на пътни превозни средства винаги, когато приближават регулировчика пред гърди или зад гърба му.'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c33f1',
        //                 name: 'Забраняващ сигнал',
        //                 image: tp6_12,
        //                 swichdOn: false,
        //                 info: 'Преминаването е забранено на водачите на пътни превозни средства винаги, когато приближават регулировчика пред гърди или зад гърба му.'
        //             },
        //             {
        //                 id: 7,
        //                 posterId: '124c33f1',
        //                 name: 'Забраняващ сигнал',
        //                 image: tp7_12,
        //                 swichdOn: false,
        //                 info: 'Преминаването е забранено на водачите на пътни превозни средства винаги, когато приближават регулировчика пред гърди или зад гърба му.'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c33f1',
        //                 name: 'Забраняващ сигнал',
        //                 image: tp8_12,
        //                 swichdOn: false,
        //                 info: 'Преминаването е забранено на водачите на пътни превозни средства винаги, когато приближават регулировчика пред гърди или зад гърба му.'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c33f1',
        //                 name: 'Забраняващ сигнал',
        //                 image: tp9_12,
        //                 swichdOn: false,
        //                 info: 'Преминаването е забранено на водачите на пътни превозни средства винаги, когато приближават регулировчика пред гърди или зад гърба му.'
        //             },
        //         ]
        //     },
        //     {
        //         id: 11,
        //         name: 'СВЕТОФАРИ',
        //         icon: trafficLightIcon,
        //         isSign: false,
        //         allSwichedOn: false,
        //         signals: [
        //             {
        //                 id: 1,
        //                 posterId: '124c35f5',
        //                 name: 'Червена светлина ',
        //                 image: tl1_11,
        //                 swichdOn: false,
        //                 info: 'Преминаването е забранено'
        //             },
        //             {
        //                 id: 2,
        //                 posterId: '124c35f5',
        //                 name: 'Едновременно светещи червена и жълта светлина',
        //                 image: tl2_11,
        //                 swichdOn: false,
        //                 info: 'Преминаването е забранено'
        //             },
        //             {
        //                 id: 3,
        //                 posterId: '124c35f5',
        //                 name: 'Преминаването разрешено',
        //                 image: tl3_11,
        //                 swichdOn: false,
        //                 info: 'За регулиране движението на пътните превозни средства по отделна пътна лента се използва светофар, с който се подават немигащи светлинни сигнали с червен и зелен цвят на светлината.'
        //             },
        //             {
        //                 id: 4,
        //                 posterId: '124c35f5',
        //                 name: 'Зелена светлина',
        //                 image: tl4_11,
        //                 swichdOn: false,
        //                 info: 'Преминаването е разрешено'
        //             },
        //             {
        //                 id: 5,
        //                 posterId: '124c35f5',
        //                 name: 'Жълта светлина ',
        //                 image: tl5_11,
        //                 swichdOn: false,
        //                 info: 'Внимание, спри!'
        //             },
        //             {
        //                 id: 6,
        //                 posterId: '124c35f5',
        //                 name: 'Червена светлина',
        //                 image: tl6_11,
        //                 swichdOn: false,
        //                 info: 'Движението по лентата е забранено'
        //             },
        //             {
        //                 id: 7,
        //                 posterId: '124c35f5',
        //                 name: 'Зелена светлина',
        //                 image: tl8_11,
        //                 swichdOn: false,
        //                 info: 'Движението по лентата е разрешено'
        //             },
        //             {
        //                 id: 8,
        //                 posterId: '124c35f5',
        //                 name: 'Червена светлина',
        //                 image: tl7_11,
        //                 swichdOn: false,
        //                 info: 'Преминаването е забранено'
        //             },
        //             {
        //                 id: 9,
        //                 posterId: '124c35f5',
        //                 name: 'Зелена светлина',
        //                 image: tl9_11,
        //                 swichdOn: false,
        //                 info: 'Преминаването е разрешено'
        //             },
        //         ]
        //     },
        // ],
        currentGroupIndex: 0,
        error: false,
        errorOverlay: false,
        errorModal: false
    })

    useEffect(() => {
        setState(prev => ({
            ...prev,
            data: app.boardStatus.data
        }))
    }, [app.boardStatus.data])

    //refs
    const infoModalRef = useRef(null)
    //end refs

    const handleChangeGroup = index => {
        setState(prev => ({
            ...prev,
            currentGroupIndex: index
        }))
    }

    const handleSwitchOn = (index, posterId, id, e) => {
        if (e.target.title) return

        let selectedGroupId = state.data[state.currentGroupIndex].id

        app.onChannelChange(selectedGroupId == 11 ? id + 13 : id - 1)
        app.onNodeChange(posterId)


        const updated = state.data.map(each => {
            if (each.id == selectedGroupId) {
                // const isAnySwitchedOn = each.signals.filter(signal => {
                //     return signal.swichdOn == false
                // })

                // each.allSwichedOn = isAnySwitchedOn.length > 0 ? false : true
                each.signals[index].swichdOn ? app.resetSelectedLeds() : app.setSelectedLeds()

                each.signals[index].swichdOn = each.signals[index].swichdOn ? false : true
            }

            return each
        })

        setState(prev => ({
            ...prev,
            data: updated
        }))
    }

    const handleSwitchAll = () => {
        let selectedGroupId = state.data[state.currentGroupIndex].id

        const updated = state.data.map(each => {
            if (each.id == selectedGroupId) {
                const isAnySwitchedOn = each.signals.filter(signal => {
                    return signal.swichdOn == false
                })
                const switchedOnIds = each.signals.map(signal => {
                    return selectedGroupId == 11 ? signal.id + 14 : signal.id
                })

                const arr = switchedOnIds

                let iterable = []
                const startIndex = arr.indexOf(1, 1)
                if (startIndex > 0) {
                    const arr2 = arr.splice(startIndex, arr.length - startIndex)
                    iterable = [arr, arr2]
                } else iterable = [arr]

                const posterIds = each.signals.map(signal => {
                    return signal.posterId
                })

                const reduceValues = posterIds.filter((id, i) => {
                    return posterIds.indexOf(id) == i;
                })

                if (isAnySwitchedOn.length > 0) {
                    for (let i = 0; i < reduceValues.length; i++) {
                        app.onNodeChange(reduceValues[i])
                        app.onChannelChange(iterable[i])

                        app.setSelectedLeds()
                    }
                } else {

                    for (let i = 0; i < reduceValues.length; i++) {
                        app.onNodeChange(reduceValues[i])
                        //Под въпрос
                        // app.setSelectedLeds(iterable[i])

                        app.onChannelChange(iterable[i])

                        app.resetSelectedLeds()
                    }
                }

                each.signals.map(signal => {
                    signal.swichdOn = isAnySwitchedOn.length > 0 ? true : false
                })

                each.allSwichedOn = isAnySwitchedOn.length > 0 ? true : false
            }

            return each
        })

        setState(prev => ({
            ...prev,
            data: updated
        }))
    }

    const handeTurnOffAll = () => {
        const updated = state.data.map(each => {
            each.signals.map(signal => {
                signal.swichdOn = false
            })

            each.allSwichedOn = false

            return each
        })

        setState(prev => ({
            ...prev,
            data: updated
        }))

        window.AVTO_API.turnAllOff('00000000')
    }

    const handleCloseError = () => {
        setState(prev => ({
            ...prev,
            errorModal: false,
        }))
        setTimeout(() => {
            setState(prev => ({
                ...prev,
                errorOverlay: false,
            }))
        }, 100)
    }

    let lightedCount = 0

    return (
        <main id="interactiveRoadSignals">
            <InfoModal
                ref={infoModalRef}
            />
            <div className="top">
                <div className="wrapper">
                    <h1>
                        Управление на табла с пътни знаци
                    </h1>
                    <p>
                        Управлението на таблата чрез отдалечен достъп е част от интеркативното обучение, което предлага платформата Авто Обучение.
                    </p>
                </div>
            </div>
            <div className="panel">
                <div className="wrapper">
                    {app.boardStatus.loading ?
                        <img src={loader} alt="loading" className="loader" />
                        :
                        app.boardStatus.connected ?
                            <>
                                <ul className="groups">
                                    {state.data[0] && state.data.map((each, i) =>
                                        <li
                                            className={state.currentGroupIndex == i ? 'active' : ''}
                                            key={each.id}
                                            onClick={() => handleChangeGroup(i)}
                                        >
                                            <img
                                                src={images[each.icon]}
                                                className="left"
                                            />
                                            <div className="mid">
                                                <span>
                                                    {each.isSign ? 'Пътни знаци' : ''}
                                                </span>
                                                <h3>
                                                    {each.name}
                                                </h3>
                                            </div>
                                            <div className="right">
                                                <span>
                                                    {lightedCount = each.signals.filter(signal => signal.swichdOn).length || ''}
                                                </span>
                                                {lightedCount > 0 ? <img src={lampIcon} /> : ''}
                                                <img src={rightArrowIcon} className="right-arrow" />
                                            </div>
                                        </li>
                                    )}

                                    <li onClick={handeTurnOffAll} className="turn-off">
                                        <img src={lampOffIcon} />
                                        <span>
                                            Изгаси всички
                                       </span>
                                    </li>
                                </ul>
                                <ul className="content">
                                    <li
                                        className={`start-all ${state?.data[state.currentGroupIndex]?.allSwichedOn ? 'active' : ''}`}
                                        onClick={handleSwitchAll}
                                    >
                                        <img src={state?.data[state.currentGroupIndex]?.allSwichedOn ? lampOffIcon : lampBigIcon} />
                            Светни всички
                            <br />
                             от {state.data[state.currentGroupIndex]?.name}
                                    </li>
                                    {state.data[state.currentGroupIndex]?.signals.map((signal, i) =>
                                        <li
                                            key={`poster_id_${signal.posterId}signal_id_${signal.id}`}
                                            className={signal.swichdOn ? 'active' : ''}
                                            id={`io${signal.id}`}
                                            onClick={e => handleSwitchOn(i, signal.posterId, signal.id, e)}
                                        >
                                            <div className="top">
                                                <img src={lampIcon} />
                                                <img
                                                    src={infoIcon}
                                                    className="info"
                                                    title="Пояснение от закона"
                                                    onClick={() => infoModalRef.current.open(signal.name, signal.info)}
                                                />
                                            </div>
                                            <img src={images[signal.image]} />
                                            <h3>
                                                {signal.name}
                                            </h3>
                                        </li>
                                    )}
                                </ul>
                            </>
                            :
                            <div className="no-connection">
                                <h2>
                                    Няма връзка с устройството!
                                </h2>
                                {/* <p>
                                    Към мрежата не е свързано устройство.
                                </p> */}
                                <Button onClick={() => app.reconnect()}>
                                    Свържи се
                                </Button>
                            </div>
                    }

                </div>
            </div>
        </main>
    )
}